import {CursorLabelModel} from './cursorLabelModel';

/*
    Модель для текстового представления маркерного курсора
*/
export class MarkerCursorLabelModel extends CursorLabelModel {
  /*
        Форматтер для значений ширины полосы по оси x
    */
  xPlotBandValueFormatter: Function | null = null;

  constructor(
    xUnits: string,
    xValueFormatter: Function | null = null,
    xPlotBandValueFormatter: Function | null = null,
  ) {
    super(xUnits, xValueFormatter);
    this.xPlotBandValueFormatter = xPlotBandValueFormatter;
  }
}
